<template>
  <div :class="containerClass">
    {{ firstCategory }}
    <span
      v-if="countRestOfCategory"
      class="font-semibold"
    >
      {{ countRestOfCategory }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: [Array, String],
      default: () => '',
    },
    maxDisplayedItem: {
      type: Number,
      default: 1,
    },
    containerClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    categories() {
      return Array.isArray(this.category) ? this.category : this.category?.split(',')
    },
    firstCategory() {
      return this.categories?.slice(0, this.maxDisplayedItem).join(', ') || '-'
    },
    countRestOfCategory() {
      const count = this.categories?.length - this.maxDisplayedItem || 0
      if (count <= 0) return ''
      return `+${count}`
    },
  },
}
</script>
